export const host = "https://api.mody.at";
